/**
 * 交易日判定（与后端 backend/main.py is_trading_day 一致）。
 *
 * 抽公共：Layout / Dashboard / Subscription 之前各自抄了一份。
 * 节假日表需与后端 _HOLIDAYS 保持同步。
 */

/** 节假日表（月-日，与后端 _HOLIDAYS 一致） */
const HOLIDAYS = [
  "1-1", "1-2", "1-3", "2-10", "2-11", "2-12", "2-13", "2-14", "2-15", "2-16", "2-17",
  "4-4", "4-5", "4-6", "5-1", "5-2", "5-3", "6-10", "6-11", "6-12",
  "9-15", "9-16", "9-17", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7",
];

/** 是否交易日（仅按周末 + 节假日判断，不含临时休市） */
export function isTradingDay(d: Date = new Date()): boolean {
  if (d.getDay() === 0 || d.getDay() === 6) return false;
  return !HOLIDAYS.includes(`${d.getMonth() + 1}-${d.getDate()}`);
}
